'use client';

import Image from 'next/image';

import abiLogo from '~/assets/images/abi_logo.png';

type AuthErrorTemplateProps = {
  children: React.ReactNode;
};

export function AuthErrorTemplate({ children }: AuthErrorTemplateProps) {
  return (
    <div className="flex justify-center items-center mx-4 min-h-[inherit]">
      <div className="flex flex-col justify-center items-center bg-gray-300 p-4 rounded max-w-xl">
        <Image src={abiLogo} placeholder="blur" alt="AB InBev" />
        {children}
      </div>
    </div>
  );
}
